import { Option } from '../../../../../models/ProviderSearch';
import { ConstantsLagoon } from '../../../../ConstantsLagoon';

export interface BhAoeItem {
  label: string;
  value: string;
  dnt_label: string;
}

export interface BhAoeCategory {
  category: string;
  items: BhAoeItem[];
}

const AOE_CATEGORY_LABELS = [
  'CONTENT_FILTERS.AREAS_OF_EXPERTISE_SUBCATEGORIES.POPULAR_SEARCHES',
  'CONTENT_FILTERS.AREAS_OF_EXPERTISE_SUBCATEGORIES.LIFESTYLE_AND_WELLNESS',
  'CONTENT_FILTERS.AREAS_OF_EXPERTISE_SUBCATEGORIES.IDENTITY',
  'CONTENT_FILTERS.AREAS_OF_EXPERTISE_SUBCATEGORIES.SPECIFIC_CONCERNS',
];

const getAoeCategoryKeys = (): string[] => {
  const config = ConstantsLagoon?.CONFIG || {};

  return [
    config.AOE_CODE_POPULAR_SEARCHES,
    config.AOE_CODE_LIFESTYLE_WELLNESS,
    config.AOE_CODE_IDENTITY,
    config.AOE_CODE_SPECIFIC_CONCERNS,
  ];
};

const parseLagoonConfigArray = (
  configValue: string | null | undefined
): string[] =>
  configValue
    ? configValue
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean)
    : [];

const getLagoonConfigValue = (allConfigs: any, key: string): string => {
  const config = allConfigs?.(key);
  return config?.value || '';
};

const getAoeCategoryMaps = (allConfigs: any): Record<string, string>[] =>
  getAoeCategoryKeys().map((key) => {
    const lagoonCodes = getLagoonConfigValue(allConfigs, key);
    const codes = parseLagoonConfigArray(lagoonCodes);
    return codes.reduce<Record<string, string>>((acc, code) => {
      //create objects  {a1:a1},{a2:a2},,}
      acc[code] = code;
      return acc;
    }, {});
  });

export const buildBhGroupedAoeData = (
  apiOptions: Option[] = [],

  allConfigs: any
): BhAoeCategory[] => {
  const cat1Items: BhAoeItem[] = [];
  const cat2Items: BhAoeItem[] = [];
  const cat3Items: BhAoeItem[] = [];
  const cat4Items: BhAoeItem[] = [];
  const categoryItems = [cat1Items, cat2Items, cat3Items, cat4Items];

  const [cat1Map, cat2Map, cat3Map, cat4Map] = getAoeCategoryMaps(allConfigs);

  for (const option of apiOptions) {
    const code = String(option.value);
    const item: BhAoeItem = {
      label: String(option.label),
      value: code,
      dnt_label: String(option.label),
    };

    if (cat1Map[code]) cat1Items.push(item);
    if (cat2Map[code]) cat2Items.push(item);
    if (cat3Map[code]) cat3Items.push(item);
    if (cat4Map[code]) cat4Items.push(item);
  }

  categoryItems.forEach((items) =>
    items.sort((a, b) => a.label.localeCompare(b.label))
  );

  return AOE_CATEGORY_LABELS.map((category, index) => ({
    category,
    items: categoryItems[index],
  })).filter((entry) => entry.items.length > 0);
};
// string building
export const buildBhGroupedAoeCategoriesCode = (
  selectedValues: string[],
  allConfigs: any
): string => {
  const [cat1Map, cat2Map, cat3Map, cat4Map] = getAoeCategoryMaps(allConfigs);

  let cat1 = '';
  let cat2 = '';
  let cat3 = '';
  let cat4 = '';

  for (const value of selectedValues) {
    const code = String(value);
    if (cat1Map[code]) cat1 = cat1 ? `${cat1},${code}` : code;
    if (cat2Map[code]) cat2 = cat2 ? `${cat2},${code}` : code;
    if (cat3Map[code]) cat3 = cat3 ? `${cat3},${code}` : code;
    if (cat4Map[code]) cat4 = cat4 ? `${cat4},${code}` : code;
  }

  return [cat1, cat2, cat3, cat4].filter(Boolean).join('|');
};
